import AnimatedCity from "../components/AnimatedCity";
import Footer from "../components/footer";
import Hero from "../components/hero";
import Navbar from "../components/navbar";
import PowerwallTimeline from "../components/PowerwallTimeline";
import SecuritySection from "../components/SecuritySection";
import Stats from "../components/stats";
import Sustainability from "../components/Sustainalibity";
import Visiion from "../components/Visiion";
import WasteToEnergy from "../components/WasteToEnergy";
import WhyDevananta from "../components/WhyDevananta";

export default function Home() {
  return (
    <main className="w-full bg-black overflow-hidden">
      <Navbar />
      <Hero />
      <AnimatedCity />
      <Sustainability />
      {/* <PowerwallTimeline /> */}
      <SecuritySection />
      {/* <Visiion /> */}
      {/* <Product />
      <AdvancedBattery />
      <DefenseEquipment />
      <WasteToEnergy /> */}
      <WhyDevananta />
      <Stats />
      {/* <Collaboration /> */}
      <Footer />
    </main>
  )
}
